import React, { useContext } from 'react'
import { MatchupContext } from '../../../../Context'
import { HeadToHead } from './HeadToHead'
import { Box } from '../../../../Components/Layout'
import { WatchMatchupCon, HeadToHeadCon } from '../styles'

export const HeadToHeadContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { matchupInfo, keyPlayerMatchup } = useContext(MatchupContext)!
  const matchupsToWatch = keyPlayerMatchup
  const summary = matchupInfo?.keyMatchupText

  return (
    <>
      {matchupsToWatch.length > 0 && (
        <Box boxColor="grey">
          <HeadToHeadCon>
            <HeadToHead matchup={matchupsToWatch} />
          </HeadToHeadCon>
          {summary && (
            <WatchMatchupCon>
              <h1>Why This Matchup?</h1>
              {summary.includes('<p>') ? (
                <div
                  className="keyMatchupCon"
                  dangerouslySetInnerHTML={{ __html: summary }}
                />
              ) : (
                <p className="keyMatchupText">{summary}</p>
              )}
            </WatchMatchupCon>
          )}
        </Box>
      )}
    </>
  )
}
